<template>

</template>
<script>
  let that;
  export default {
    name: 'App',
    data(){

    },
    created(){
      this.$router.go(-1)
    },
    methods:{
    }
  }
</script>




// WEBPACK FOOTER //
// src/pages/home/supplierAllBack.vue